import { useState } from "react";
import { Button, TextField } from "@mui/material";
import "../../../styles/StartAConversation.css";
import TabLayout from "../../../lib/bandung/components/helpers/TabLayout";

function ProfileSettingsAccountTab() {
  const [url, setUrl] = useState("");

  const handleChange = (e) => setUrl(e.target.value);

  return (

  
      <div className="Inputs w-96 h-auto flex flex-col  justify-center  space-y-6 mx-auto"> {/* Centering and spacing */}
        <div className="ProfileContactInformation w-80 text-2xl font-bold font-['Inter'] leading-normal whitespace-nowrap text-center">
          Create New Company
        </div>
    
        <div className="InputFieldWithLabel w-full flex flex-col space-y-2">
          <div className="Email text-base font-medium font-['Inter'] leading-normal">Company Name</div>
          <div className="Field w-full px-4 py-3 bg-white rounded-lg shadow border border-neutral-200 flex items-center">
            <div className="Label w-full text-zinc-500 text-base font-medium font-['Inter'] leading-normal">
              i.e. My Company
            </div>
          </div>
        </div>
    
        <div className="InputFieldWithLabel w-full flex flex-col space-y-2">
          <div className="Email text-base font-medium font-['Inter'] leading-normal">Email</div>
          <div className="Field w-full px-4 py-3 bg-white rounded-lg shadow border border-neutral-200 flex items-center">
            <div className="Label w-full text-zinc-500 text-base font-medium font-['Inter'] leading-normal">
              i.e. mycompany@email
            </div>
          </div>
        </div>
    
        <div className="InputFieldWithLabel w-full flex flex-col space-y-2">
          <div className="Password text-base font-medium font-['Inter'] leading-normal">Categories</div>
          <div className="Field w-full px-4 py-3 bg-white rounded-lg shadow border border-neutral-200 flex items-center">
            <div className="Label w-full text-zinc-500 text-base font-medium font-['Inter'] leading-normal">
              Company Phone Number
            </div>
          </div>
        </div>
    
        <div className="InputFieldWithLabel w-full flex flex-col space-y-2">
          <div className="Password text-base font-medium font-['Inter'] leading-normal">Description</div>
          <div className="Field w-full px-4 py-3 bg-white rounded-lg shadow border border-neutral-200 flex items-center">
            <div className="Label w-full text-zinc-500 text-base font-medium font-['Inter'] leading-normal">
              Describe what your company does
            </div>
          </div>
        </div>
    
        <div className="SaveButton">
          <div className="Button w-45 px-4  py-3.5 bg-rose-800 rounded-lg shadow flex justify-center items-center">
            <div className="ApplyAndSaveChanges text-white text-base font-medium font-['Inter'] leading-normal">
              Create New Company
            </div>
          </div>
        </div>
      </div>
    );
    

 
}


export default ProfileSettingsAccountTab;
